export class Constants {
  
    public static add_document_icon = "note_add";
    public static edit_document_icon = "edit";
    public static save_icon = "save";
    public static language_icon = "language";
    public static delete_icon = "delete_forever";
    public static cancel_icon ="cancel";
    public static upload_icon ="cloud_upload";
    public static back_icon ="arrow_back";
    public static translate_icon="g_translate";
    public static menu_icon: string = "radio_button_checked";

    public static ico_formats: string[] = ['image/png','image/x-icon','image/icon','image/vnd.microsoft.icon']
    public static logo_formats: string[] = ['image/jpeg','image/png']
    public static image_formats : string[] = ['image/jpeg']
}